import React from "react";
import { useParams } from "react-router-dom";
import { ChangeServicePageNew } from "@App/components/@remote";

export const ChangeServiceNew = () => {
  const { category, sofId } = useParams();
  return <ChangeServicePageNew category={category as "strom" | "gas" | "heizstrom"} sofId={sofId} />;
};
